import React from "react";
import { SvgIcon } from "@mui/material";
import { cleanIconProps } from "./cleanIconProps";

const AddCircleIcon = (props) => {
  return (
    <SvgIcon
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
      {...cleanIconProps(props)}
    >
      <circle
        style={{ ...props.circleStyle }}
        className="add-circle-1"
        cx="150.37435"
        cy="150"
        r="107.67446"
      />
      <path
        className="add-circle-2"
        d="M204.09157,135.414H164.9604V96.28309a14.58605,14.58605,0,0,0-29.1721,0V135.414H96.65744a14.58605,14.58605,0,0,0,0,29.1721H135.7883v39.13086a14.58605,14.58605,0,1,0,29.1721,0V164.58605h39.13117a14.58605,14.58605,0,0,0,0-29.1721Z"
      />
    </SvgIcon>
  );
};

export default AddCircleIcon;
